import makeFetchCall from './makeFetchCall.js';

const loadDataEndpoint = '/api/grab-the-good-stuff';

const initAppData = async () => {
    try {
        return await makeFetchCall(loadDataEndpoint, null, 'GET');
    } catch (e) {
        console.error('Unable to fetch init state data', e);
        return {};
    }
};

export default initAppData;
